import React from 'react'
import { css } from 'glamor'

import { colors, settings } from '@dooer/react-ui-kit'

import VideoPlayer from './video-player'
import { useQuery } from 'react-apollo'
import { getVideo } from './gql'

const styles = {
  wrapper: {
    base: {
      backgroundColor: colors.backgrounds.content,
      borderBottom: settings.borders.regular,
      marginBottom: settings.spacing.large,
    },
  },
}

export default function AcademyVideoPlayer(props: { videoId: string }) {
  const { data, loading, error } = useQuery(getVideo, {
    variables: {
      id: props.videoId,
    },
  })

  if (loading) {
    return null
  }

  if (error) {
    return null
  }

  const currentVideo = data.academy.video

  return (
    <div {...css(styles.wrapper.base)}>
      <VideoPlayer controls video={currentVideo.videoSource} width={560} />
    </div>
  )
}
